import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";
import { DynamicViewEngineModule } from "@cotecna/dynamic-view-engine";
import { FileManagementModule } from "@cotecna/file-management";

import { DynamicFormDialogComponent } from "./components/natural-form-dialog/dynamic-form-dialog.component";
@NgModule({
  declarations: [DynamicFormDialogComponent],
  imports: [
    CommonModule,
    DynamicViewEngineModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    FileManagementModule,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FormDialogModule {}
